import { create } from 'zustand';
import { api } from './api';

const persistKey = 'poke_auth';

function loadAuth() {
  try {
    const raw = localStorage.getItem(persistKey);
    if (!raw) return { token: null, user: null };
    return JSON.parse(raw);
  } catch {
    return { token: null, user: null };
  }
}

function saveAuth(state) {
  localStorage.setItem(persistKey, JSON.stringify({ token: state.token, user: state.user }));
  if (state.token) localStorage.setItem('poke_token', state.token);
  else localStorage.removeItem('poke_token');
}

export const useAuthStore = create((set, get) => ({
  ...loadAuth(),
  setAuth: (token, user) => {
    set({ token, user });
    saveAuth({ token, user });
  },
  logout: () => {
    set({ token: null, user: null });
    saveAuth({ token: null, user: null });
  },
  refreshMe: async () => {
    try {
      const res = await api.get('/auth/me');
      set({ user: res.data });
      saveAuth({ token: get().token, user: res.data });
      return res.data;
    } catch {
      set({ token: null, user: null });
      saveAuth({ token: null, user: null });
      return null;
    }
  },
}));

// hydrate token to localStorage 'poke_token' at boot
const boot = loadAuth();
if (boot.token) localStorage.setItem('poke_token', boot.token); else localStorage.removeItem('poke_token');
